import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

const MetricAltAvatar = styled(props => <Avatar {...props} />)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.iconInfo,
  width: theme.spacing(6),
  height: theme.spacing(6)
}));

function NRMetricBanner({ metric, result, icon, rightIcon, externalSx }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        ...externalSx
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <MetricAltAvatar>{icon}</MetricAltAvatar>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', ml: theme.spacing(1) }}>
        <Typography variant="label" color="text.secondary" children={metric} />
        <Typography variant="h3" children={result} />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
        <Box>{rightIcon}</Box>
      </Box>
    </Box>
  );
}
export default NRMetricBanner;
